import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MemberAccess } from 'app/trello/models/member-access';
import { RequestErrorThrower } from 'app/trello/services/request-error-thrower';
import { TokenService } from 'app/trello/services/token.service';
import { environment } from 'environments/environment';
import { catchError, Observable, switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MemberAccessFetcher {

  constructor(
    private readonly http: HttpClient,
    private readonly requestErrorThrower: RequestErrorThrower,
    private readonly tokenService: TokenService,
  ) {
  }

  public fetch(): Observable<MemberAccess> {

    const url = `${environment.apiRoot}${environment.endpoints.memberAccess}`;

    return this.tokenService.userToken
      .pipe(
        take(1),
        switchMap((userToken) =>

          this.http.get<MemberAccess>(
            url,
            {headers: {Authorization: `Bearer ${userToken}`}},
          )
        ),
        catchError((error: any) => {

          console.error('An error occurred fetching member access:', error);

          return this.requestErrorThrower.throwError(error);
        }),
      );
  }

}
